import { render } from "./publications-workshop-form.vue?vue&type=template&id=3e10fb6c&scoped=true"
import script from "./publications-workshop-form.vue?vue&type=script&lang=js"
export * from "./publications-workshop-form.vue?vue&type=script&lang=js"

import "./publications-workshop-form.vue?vue&type=style&index=0&id=3e10fb6c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e10fb6c"]])

export default __exports__